import _ from 'lodash';
import { InputHelper } from './InputHelper';
import * as ExcelJS from 'exceljs';
import { enmPdfRendererType } from '../models/enums/PdfRenderer';
import { mdlPDFRendererProps } from '../models/ui-models/PDFRendererProps';
import { enmPdfExportType } from '../models/enums/PdfExportType';

module ExportHelper {
  export function exportToPDFTable(fileName: string, type: enmPdfExportType, heads: string[], rows: string[][]) {
    return {
      params: { name: fileName, heads: heads, rows: rows },
      rendererType: enmPdfRendererType.PDFTable,
      type: type
    } as mdlPDFRendererProps
  }

  export async function exportToExcel(fileName: string, tableHead: Array<string | { label: string, style?: any }>, rowData?: Array<Array<string | undefined | { value: string | undefined, style?: any }>>) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(fileName.length > 31 ? fileName.substring(0, 31) : fileName);

    // Başlıkları ekle
    const headerRow = worksheet.addRow(tableHead.map(head => typeof head === 'string' ? head : head.label));

    // Başlık stillerini uygula
    tableHead.forEach((head, index) => {
      if (typeof head === 'object' && head.style) {
        const cell = headerRow.getCell(index + 1);
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: head.style.fill.fgColor.argb }
        };
      }
    });

    // Satırları ekle
    if (rowData) {
      rowData.forEach(row => {
        const excelRow = worksheet.addRow(row.map(cell => {
          if (typeof cell === 'object' && cell !== null) {
            return cell.value;
          }
          return cell;
        }));

        // Satır stillerini uygula
        row.forEach((cell, index) => {
          if (typeof cell === 'object' && cell !== null && cell.style) {
            const excelCell = excelRow.getCell(index + 1);
            excelCell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: cell.style.fill.fgColor.argb }
            };
          }
        });
      });
    }

    // Kolonları otomatik genişlet
    worksheet.columns.forEach(column => {
      column.width = 15;
    });

    // Excel dosyasını kaydet
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.xlsx`;
    link.click();
    window.URL.revokeObjectURL(url);
  }
}
export default ExportHelper;
